import axios from 'axios';
import Qs from 'qs';
import store from '@/vuex/store';
import { Message } from 'element-ui';
// let base = '';
// let base = 'http://localhost:5997';

//对外地址
let base = process.env.API_ROOT;
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型

// 请求拦截
axios.interceptors.request.use(
    config => {
      // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
      
      // config.data = JSON.stringify(config.data);
     
      // console.log(JSON.stringify(config.data)+'111');
      config.headers = {
        'Content-Type':'application/json',
        'DreamToken':store.state.token,
        'X-Requested-With':'XMLHttpRequest',
         'sign':'' 
      }
 
 
    //  接口签名对请求数据 加密验证防止串改  后台并未实现 拦截验证
     if (config.method == "get"){
      var newParams = config.params;
      // console.log(newParams);
      if (newParams == undefined) {
        newParams = new Object();
      }
      newParams.signTime = new Date().getTime();
      //加密过程
      // config.headers.sign = EncryptData(JSON.stringify(newParams));
      // console.log(JSON.stringify(newParams));
     }
     if (config.method == "post"){
      var newData = config.data;
      if (newData == undefined) {
        newData = new Object();
      }
      newData.signTime = new Date().getTime();

      // console.log(JSON.stringify(newData));
     }
      
      return config;
    },
    error => {
      return Promise.reject(err);
    }
  );
// 拦截响应response，并做一些错误处理

axios.interceptors.response.use((response)=>{
  const data = response.data

  // console.log(response);
  switch (data.code) {
    case 200:
        // console.log(data.code);
       return response;
    case 500:
        this.$message({
        message: Msg,
        type: 'success'
      });
      return ;
    default:
  }

  return response;
},(err)=>{
//  console.log(err);

 return Promise.reject(err);
}

)





// http://localhost:46286/

export const requestLogin=params=>{return axios.post(`${base}/user/login`,params).then(res=>res.data);};
export const requestLogout=params=>{return axios.post(`${base}/user/Logout`,params);};
export const userChangeState=params=>{return axios.post(`${base}/user/ChangeState`,params);};


//定位
export const DistJsonList=params=>{return axios.post(`${base}/ProvCityDist/DistJsonList`,params);};
export const CreateShopDist=params=>{return axios.post(`${base}/ShopProvCityDist/CreateShopDist`,params);};
export const GetHtmlValue=params=>{return axios.post(`${base}/ShopProvCityDist/GetHtmlValue`,params);};
export const JsonList=params=>{return axios.post(`${base}/Shop/JsonList`,params);};
export const GetDistShopList=params=>{return axios.post(`${base}/Shop/GetDistShopList`,params);};
export const ChangeVersionStyle=params=>{return axios.post(`${base}/Shop/ChangeVersionStyle`,params);};



  // 本都数据模拟登陆地址
// export const requestLogin = params => { return axios.post(`${base}/user/login`, params).then(res => res.data); };



// export const getUserList = params => { return axios.get(`${base}/user/list`, { params: params }); };


// export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

// export const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };

// export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

// export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };

export const getConsumptionList=params=>{return axios.get(`${base}/Consumption/GetPaging`,{params:params});}
//基础用户信息
export const getbasicListPage = params => { return axios.get(`${base}/BasicInformation/GetPaging`, { params: params }); };
export const editBasicInfoMember=params=>{return axios.post(`${base}/BasicInformation/Edit`,params);};
export const addBasicinfo = params => { return axios.post(`${base}/BasicInformation/Create`,params);};
export const getBasicList = params => { return axios.get(`${base}/BasicInformation/GetList`, { params: params }); };
export const BasicinfoChangeState = params => { return axios.post(`${base}/BasicInformation/ChangeState`,params);};
export const ExportBinding = params => { return axios.post(`${base}/BasicInformation/ExportBinding`,params,{responseType: 'blob'});};
export const GetTotleBanding = params => { return axios.get(`${base}/BasicInformation/GetTotleBanding`, { params: params }); };


//会员管理模块
export const getMemberListPage = params => { return axios.get(`${base}/Member/GetPaging`, { params: params }); };
export const addMember = params => { return axios.post(`${base}/Member/Create`,params);};
export const removeUser = params => { return axios.post(`${base}/Member/Delete`,params);};
export const ReplaceCard = params => { return axios.post(`${base}/Business/ReplaceCard`,params);};
export const getMemberList = params => { return axios.get(`${base}/Member/GetList`, { params: params }); };
export const getMemberCount = params => { return axios.get(`${base}/Member/GetCount`, { params: params }); };
export const Backups = params => { return axios.post(`${base}/Member/Backups`,params,{responseType: 'blob'});};
export const BackData = params => { return axios.post(`${base}/Member/BackData`,params,{responseType: 'blob'});};
export const BackupAll = params => { return axios.post(`${base}/Member/BackupAll`,params,{responseType: 'blob'});};
export const ShiftPlan = params => { return axios.post(`${base}/ShiftPlan/ShiftPlan`,params);};
export const UploadMemberImage=params=>{return axios.post(`${base}/MemberImage/UploadImage`,params);};
export const Download=params=>{return axios.post(`${base}/ImageFile/Download`,params);};
export const GetMemberInfoByCard = params => { return axios.post(`${base}/Member/GetMemberInfoByCard`,params);};
export const MemberChangeState = params => { return axios.post(`${base}/Member/ChangeState`,params);};
export const UploadSinglePhoto=params=>{return axios.post(`${base}/MemberImage/UploadSinglePhoto`,params);};
export const GetComboList = params => { return axios.get(`${base}/Member/GetComboList`, { params: params }); };



//图片上传
export const Upload=params=>{return axios.post(`${base}/MemberImage/Upload`,params);};

// export const ImageGetList=params=>{return axios.post(`${base}/MemberImage/GetList`,params);};
export const ImageGetList = params => { return axios.get(`${base}/MemberImage/GetList`, { params: params }); };
export const ImageDelete = params => { return axios.post(`${base}/MemberImage/Delete`,  params ); };

// http://localhost:46286/Api/ImageFile/Download/
// 微信会员
export const getWeChatMemberListPage = params => { return axios.get(`${base}/WeChatMember/GetPaging`, { params: params }); };
export const getWeChatMemberCount = params => { return axios.get(`${base}/WeChatMember/GetCount`, { params: params }); };
export const ExportBusiness = params => { return axios.post(`${base}/WeChatMember/ExportBusiness`,params,{responseType: 'blob'});};


// export const GetMemberInfoByIcCard=params=>{return axios.get(`${base}/Member/GetMemberInfoByIcCard`,{params:params});};
export const editMember=params=>{return axios.post(`${base}/Member/Edit`,params);};
//修改密码
export const ChangePassword = params => { return axios.post(`${base}/User/ChangePassword`,  params ); };

// -门店管理模块-门店账号 shopmanagement-shopuser
export const getshopUser=params=>{return axios.get(`${base}/User/GetPaging`,{params:params});};
export const removeshopUser = params => { return axios.post(`${base}/User/Delete`,  params ); };
export const addshopUser = params => { return axios.post(`${base}/User/Create`,  params ); };
export const editshoptUser = params => { return axios.post(`${base}/User/Edit`,   params ); };
export const ResetPassword = params => { return axios.post(`${base}/User/ResetPassword`,   params ); };
export const RandomResetTwoPassword = params => { return axios.post(`${base}/User/RandomResetTwoPassword`,   params ); };
export const ChangeTwoPassword = params => { return axios.post(`${base}/User/ChangeTwoPassword`,   params ); };



// export const getshopInfor = params => { return axios.get(`${base}/shopuser/shopInfor`, { params: params }); };

// 门店管理模块-门店信息  shopmanagement-shopinfo
// export const getshopInfor=params=>{return axios.get(`${base}/ShopManagement/shopinfo`,{ params: params })};
// 门店管理模块-门店列表 shopmanagement-shoplist
export const getShopInfor=params=>{return axios.get(`${base}/Shop/GetList`,{params:params})};
export const getShopList=params=>{return axios.get(`${base}/Shop/GetPaging`,{params:params});};
export const removeshop=params=>{return axios.post(`${base}/Shop/Delete`,params);};
export const editshopt=params=>{return axios.post(`${base}/Shop/Edit`,params);};
export const addshop=params=>{return axios.post(`${base}/Shop/Create`,params);};
export const SaveIntroduction=params=>{return axios.post(`${base}/Shop/SaveIntroduction`,params);};
export const SavePaymentInfo=params=>{return axios.post(`${base}/Shop/SavePaymentInfo`,params);};
export const ShopPayStatistics=params=>{return axios.post(`${base}/Shop/ShopPayStatistics`,params);};
export const ShopOnlineSet=params=>{return axios.post(`${base}/Shop/OnlineSet`,params);};
export const MsgPowerSet=params=>{return axios.post(`${base}/Shop/MsgPowerSet`,params);};
export const MachineStateSet=params=>{return axios.post(`${base}/Shop/MachineStateSet`,params);};
export const TimeLimitSet=params=>{return axios.post(`${base}/Shop/TimeLimitSet`,params);};
export const ChangePattern=params=>{return axios.post(`${base}/Shop/ChangePattern`,params);};
export const ChangeEvaluateState=params=>{return axios.post(`${base}/Shop/ChangeEvaluateState`,params);};
export const ChangeCertificateState=params=>{return axios.post(`${base}/Shop/ChangeCertificateState`,params);};
export const ChangeShopCompetitionState=params=>{return axios.post(`${base}/Shop/ChangeCompetitionState`,params);};
export const GetBindingList=params=>{return axios.get(`${base}/Shop/GetBindingList`,{params:params})};
export const ShopUserList=params=>{return axios.post(`${base}/Shop/ShopUserList`,params);};
export const ChangeShopOneCardSystemState=params=>{return axios.post(`${base}/Shop/ChangeOneCardSystemState`,params);};




//微信管理

export const addWeChatOfficialAccount=params=>{return axios.post(`${base}/WeChatOfficialAccount/Create`,params);};
export const getWeChatOfficialAccountList=params=>{return axios.get(`${base}/WeChatOfficialAccount/GetPaging`,{params:params});};
export const editWeChatOfficialAccount=params=>{return axios.post(`${base}/WeChatOfficialAccount/Edit`,params);};
export const removeWeChatOfficialAccount=params=>{return axios.post(`${base}/WeChatOfficialAccount/Delete`,params);};
export const getWeChatAccountList=params=>{return axios.get(`${base}/WeChatOfficialAccount/GetList`,{params:params})};
export const ChangeActivationState=params=>{return axios.post(`${base}/WeChatOfficialAccount/ChangeActivationState`,params);};
export const WeChatOfficialAccountChangeState=params=>{return axios.post(`${base}/WeChatOfficialAccount/ChangeState`,params);};
export const GenerateQRcode=params=>{return axios.post(`${base}/WeChatOfficialAccount/GenerateQRcode`,params);};
export const GetGenerate=params=>{return axios.post(`${base}/WeChatOfficialAccount/GetGenerate`,params);};
export const DownloadImage=params=>{return axios.post(`${base}/WeChatOfficialAccount/DownloadImage`,params,{responseType: 'blob'});};

export const GetSignData=params=>{return axios.post(`${base}/WeChatOfficialAccount/GetSignData`,params);};
export const AccountUploadImage=params=>{return axios.post(`${base}/WeChatOfficialAccount/UploadImage`,params);};


export const addWeChatOfficialBinding=params=>{return axios.post(`${base}/WeChatOfficialBinding/Binding`,params);};
export const getWeChatOfficialBinding=params=>{return axios.get(`${base}/WeChatOfficialBinding/GetList`,{params:params})};
export const removeWeChatOfficialBinding=params=>{return axios.post(`${base}/WeChatOfficialBinding/Delete`,params);};

// export const ChangeDimensionState=params=>{return axios.post(`${base}/WeChatOfficialAccount/ChangeState`,params);};





export const shopUploadImage=params=>{return axios.post(`${base}/Shop/UploadImage`,params);};

export const rechargeshop=params=>{return axios.post(`${base}/Shop/Recharge`,params);};
export const rechargeLogPaging=params=>{return axios.get(`${base}/ShopRechargeLog/GetPaging`,{params:params});};
export const CancelOrder=params=>{return axios.post(`${base}/Business/CancelOrder`,params);};
export const ShopStatisticsList=params=>{return axios.post(`${base}/Shop/ShopStatistics`,params);};
export const Statistics=params=>{return axios.post(`${base}/EventLog/Statistics`,params);};
export const MsgStatistics=params=>{return axios.post(`${base}/EventLog/MsgStatistics`,params);};
export const MonthMsgStatistics=params=>{return axios.post(`${base}/EventLog/MonthMsgStatistics`,params);};
export const ExportMonthMsgStatistics=params=>{return axios.post(`${base}/EventLog/ExportMonthMsgStatistics`,params,{responseType: 'blob'});};
export const ShopPayViewMsgStatistics=params=>{return axios.post(`${base}/EventLog/ShopPayViewMsgStatistics`,params);};
export const MSMConsumeDetail=params=>{return axios.post(`${base}/EventLog/MSMConsumeDetail`,params);};



//刷卡记录
export const addRecord=params=>{return axios.post(`${base}/Record/Create`,params);};
export const getRecord=params=>{return axios.get(`${base}/Record/GetPaging`,{params:params});};


//评价维度管理
export const addDimension=params=>{return axios.post(`${base}/Dimension/Create`,params);};
export const getDimensionList=params=>{return axios.get(`${base}/Dimension/GetPaging`,{params:params});};
export const editDimension=params=>{return axios.post(`${base}/Dimension/Edit`,params);};
export const removeDimension=params=>{return axios.post(`${base}/Dimension/Delete`,params);};
export const ChangeDimensionState=params=>{return axios.post(`${base}/Dimension/ChangeState`,params);};

export const addCertificate=params=>{return axios.post(`${base}/CertificateTemplate/Create`,params);};
export const getCertificateList=params=>{return axios.get(`${base}/CertificateTemplate/GetPaging`,{params:params});};
export const editCertificate=params=>{return axios.post(`${base}/CertificateTemplate/Edit`,params);};
export const removeCertificate=params=>{return axios.post(`${base}/CertificateTemplate/Delete`,params);};
export const UploadCertificateImage=params=>{return axios.post(`${base}/CertificateTemplate/UploadImage`,params);};

//学员证书
export const addStudentCertificate=params=>{return axios.post(`${base}/Certificate/Create`,params);};
export const getStudentCertificateList=params=>{return axios.get(`${base}/Certificate/GetPaging`,{params:params});};
export const editStudentCertificate=params=>{return axios.post(`${base}/Certificate/Edit`,params);};
export const removeStudentCertificate=params=>{return axios.post(`${base}/Certificate/Delete`,params);};

//基础设置  延期
export const ComboPostPone=params=>{return axios.post(`${base}/Business/ComboPostPone`,params);};
export const PostPone=params=>{return axios.post(`${base}/Business/PostPone`,params);};

//
//基础设置
//次卡设置
export const getFrequencyCardOptionsList=params=>{return axios.get(`${base}/FrequencyCardCombo/GetList`,{params:params})};
export const getFrequencyCardList=params=>{return axios.get(`${base}/FrequencyCardCombo/GetPaging`,{params:params});};
export const addFrequencyCard=params=>{return axios.post(`${base}/FrequencyCardCombo/Create`,params);};
export const editFrequencyCard=params=>{return axios.post(`${base}/FrequencyCardCombo/Edit`,params);};
export const removeFrequencyCard=params=>{return axios.post(`${base}/FrequencyCardCombo/Delete`,params);};
export const OnlineSet=params=>{return axios.post(`${base}/FrequencyCardCombo/OnlineSet`,params);};


//基础设置微信设置
export const WeiXinSettPagList=params=>{return axios.get(`${base}/WeiXinSett/GetPaging`,{params:params})};
export const editWeiXinSett=params=>{return axios.post(`${base}/WeiXinSett/Edit`,params);};

//微信模块  获取授权相关信息
export const WeiXinSettOptionsList=params=>{return axios.get(`${base}/WeiXinSett/GetList`,{params:params})};


//月卡 
export const getMonthCardOptionsList=params=>{return axios.get(`${base}/MonthCardCombo/GetList`,{params:params})};
export const getMonthCardList=params=>{return axios.get(`${base}/MonthCardCombo/GetPaging`,{params:params});};
export const addMonthCard=params=>{return axios.post(`${base}/MonthCardCombo/Create`,params);};
export const editMonthCard=params=>{return axios.post(`${base}/MonthCardCombo/Edit`,params);};
export const removeMonthCard=params=>{return axios.post(`${base}/MonthCardCombo/Delete`,params);};
export const MonthCardOnlineSet=params=>{return axios.post(`${base}/MonthCardCombo/OnlineSet`,params);};


//年卡
export const getYearCardOptionsList=params=>{return axios.get(`${base}/YearCardCombo/GetList`,{params:params})};
export const getYearCardList=params=>{return axios.get(`${base}/YearCardCombo/GetPaging`,{params:params});};
export const addYearCard=params=>{return axios.post(`${base}/YearCardCombo/Create`,params);};
export const editYearCard=params=>{return axios.post(`${base}/YearCardCombo/Edit`,params);};
export const removeYearCard=params=>{return axios.post(`${base}/YearCardCombo/Delete`,params);};
export const YearCardOnlineSet=params=>{return axios.post(`${base}/YearCardCombo/OnlineSet`,params);};

//充值卡
export const getRechargeableCardOptionsList=params=>{return axios.get(`${base}/RechargeableCardCombo/GetList`,{params:params})};
export const getRechargeableCardList=params=>{return axios.get(`${base}/RechargeableCardCombo/GetPaging`,{params:params});};
export const addRechargeableCard=params=>{return axios.post(`${base}/RechargeableCardCombo/Create`,params);};
export const editRechargeableCard=params=>{return axios.post(`${base}/RechargeableCardCombo/Edit`,params);};
export const removeRechargeableCard=params=>{return axios.post(`${base}/RechargeableCardCombo/Delete`,params);};
export const RechargeableCardOnlineSet=params=>{return axios.post(`${base}/RechargeableCardCombo/OnlineSet`,params);};


//培训卡
export const getTrainingCardOptionsList=params=>{return axios.get(`${base}/TrainingCombo/GetList`,{params:params})};
export const getTrainingCardList=params=>{return axios.get(`${base}/TrainingCombo/GetPaging`,{params:params});};
export const addTrainingCard=params=>{return axios.post(`${base}/TrainingCombo/Create`,params);};
export const editTrainingCard=params=>{return axios.post(`${base}/TrainingCombo/Edit`,params);};
export const removeTrainingCard=params=>{return axios.post(`${base}/TrainingCombo/Delete`,params);};
export const IntervalDateList=params=>{return axios.post(`${base}/TrainingCombo/IntervalDateList`,params);};
export const IntervalPlan=params=>{return axios.post(`${base}/ShiftPlan/IntervalPlan`,params);};
export const TrainingOnlineSet=params=>{return axios.post(`${base}/TrainingCombo/OnlineSet`,params);};
export const LimitCount=params=>{return axios.post(`${base}/TrainingCombo/LimitCount`,params);};
export const GetDetails=params=>{return axios.post(`${base}/TrainingCombo/Details`,params);};



//业主卡
export const OwnerCardOptionsList=params=>{return axios.get(`${base}/OwnerCardCombo/GetList`,{params:params})};
export const getOwnerCardList=params=>{return axios.get(`${base}/OwnerCardCombo/GetPaging`,{params:params});};
export const addOwnerCard=params=>{return axios.post(`${base}/OwnerCardCombo/Create`,params);};
export const editOwnerCard=params=>{return axios.post(`${base}/OwnerCardCombo/Edit`,params);};
export const removeOwnerCard=params=>{return axios.post(`${base}/OwnerCardCombo/Delete`,params);};
export const CheckReset=params=>{return axios.post(`${base}/OwnerCardCombo/CheckReset`,params);};


export const BatchUpdateOwnerCardSurplus=params=>{return axios.post(`${base}/Business/BatchUpdateOwnerCardSurplus`,params);};
export const PartUpdateOwnerCardSurplus=params=>{return axios.post(`${base}/Business/PartUpdateOwnerCardSurplus`,params);};
export const OwnerCardConsumption=params=>{return axios.post(`${base}/Business/OwnerCardConsumption`,params);};
export const DataCompensation=params=>{return axios.post(`${base}/Business/DataCompensation`,params);};
export const Recharge=params=>{return axios.post(`${base}/Business/Recharge`,params);};



//教练设置
export const getCoachList=params=>{return axios.get(`${base}/Coach/GetPaging`,{params:params});};
export const addCoach=params=>{return axios.post(`${base}/Coach/Create`,params);};
export const editCoach=params=>{return axios.post(`${base}/Coach/Edit`,params);};
export const removeCoach=params=>{return axios.post(`${base}/Coach/Delete`,params);};
export const getCoachOptionsList=params=>{return axios.get(`${base}/Coach/GetList`,{params:params})};
export const Report=params=>{return axios.post(`${base}/Coach/Report`,params);};
export const ReportDay=params=>{return axios.post(`${base}/Coach/ReportDay`,params);};

export const ExportReportDay=params=>{return axios.post(`${base}/Coach/ExportReportDay`,params,{responseType: 'blob'});};

export const ExportReport=params=>{return axios.post(`${base}/Coach/ExportReport`,params,{responseType: 'blob'});};
export const ExportReportDetail=params=>{return axios.post(`${base}/Coach/ExportReportDetail`,params,{responseType: 'blob'});};

export const UploadImage=params=>{return axios.post(`${base}/Coach/UploadImage`,params);};
export const UploadSeal=params=>{return axios.post(`${base}/Coach/UploadSeal`,params);};
export const ExportStudent=params=>{return axios.post(`${base}/Coach/Export`,params,{responseType: 'blob'});};




//评价管理
export const getEvaluateList=params=>{return axios.get(`${base}/Evaluate/GetPaging`,{params:params});};
export const getEvaluateReport=params=>{return axios.get(`${base}/Evaluate/GetReport`,{params:params});};
export const getEvaluateItem=params=>{return axios.post(`${base}/Evaluate/EvaluateItem`,params);};

//门店评价
export const getEvaluateShopList=params=>{return axios.get(`${base}/EvaluateShop/GetPaging`,{params:params});};
export const SumValue=params=>{return axios.post(`${base}/EvaluateShop/Sum`,params);};


//评价修改 
export const EvaluateShopEditLogs=params=>{return axios.get(`${base}/EvaluateShopEditLogs/GetPaging`,{params:params});};
//评价修改的维度
export const EvaluateDimensionEditLogs=params=>{return axios.get(`${base}/EvaluateDimensionEditLogs/GetPaging`,{params:params});};
//回复
export const Reply=params=>{return axios.post(`${base}/EvaluateShop/Reply`,params);};
//评价导出
export const ShopSumExport = params => { return axios.post(`${base}/EvaluateShop/ShopSumExport`,params,{responseType: 'blob'});};
export const SumExport = params => { return axios.post(`${base}/EvaluateShop/SumExport`,params,{responseType: 'blob'});};



//更换教练 log
export const getReplaceCoachLogList=params=>{return axios.get(`${base}/ReplaceCoachLog/GetPaging`,{params:params});};
export const ReplaceCoach=params=>{return axios.post(`${base}/ReplaceCoachLog/ReplaceCoach`,params);};
export const getReplaceCoachLogOptionsList=params=>{return axios.get(`${base}/ReplaceCoachLog/GetList`,{params:params})};
//重置日志
export const getResetCardLogList=params=>{return axios.get(`${base}/ResetCardLog/GetPaging`,{params:params});};
// export const getReplaceCoachLogOptionsList=params=>{return axios.get(`${base}/ResetCardLog/GetList`,{params:params})};
//延期日子
export const PostPoneLogPaging=params=>{return axios.get(`${base}/PostPoneLog/GetPaging`,{params:params});};


//消费项目设置
export const getConsumptionComboOptionsList=params=>{return axios.get(`${base}/RechargeableCardConsumptionCombo/GetList`,{params:params})};
export const getConsumptionComboList=params=>{return axios.get(`${base}/RechargeableCardConsumptionCombo/GetPaging`,{params:params});};
export const addConsumptionCombo=params=>{return axios.post(`${base}/RechargeableCardConsumptionCombo/Create`,params);};
export const editConsumptionCombo=params=>{return axios.post(`${base}/RechargeableCardConsumptionCombo/Edit`,params);};
export const removeConsumptionCombo=params=>{return axios.post(`${base}/RechargeableCardConsumptionCombo/Delete`,params);};
//时间段设置
export const getIntervalList=params=>{return axios.get(`${base}/Interval/GetList`,{params:params})};
// export const getConsumptionComboList=params=>{return axios.get(`${base}/RechargeableCardConsumptionCombo/GetPaging`,{params:params});};
export const addInterval=params=>{return axios.post(`${base}/Interval/Create`,params);};
// export const editConsumptionCombo=params=>{return axios.post(`${base}/RechargeableCardConsumptionCombo/Edit`,params);};
// export const removeConsumptionCombo=params=>{return axios.post(`${base}/RechargeableCardConsumptionCombo/Delete`,params);};


//业务中心 Business
export const FrequencyCardBusiness=params=>{return axios.post(`${base}/Business/FrequencyCardBusiness`,params);};
export const TrainingCardBusiness=params=>{return axios.post(`${base}/Business/TrainingCardBusiness`,params);};
export const MonthCardBusiness=params=>{return axios.post(`${base}/Business/MonthCardBusiness`,params);};
export const YearCardBusiness=params=>{return axios.post(`${base}/Business/YearCardBusiness`,params);};
//微信会员改为系统会员 ChangeWeChatInfo
export const ChangeWeChatInfo=params=>{return axios.post(`${base}/Business/ChangeWeChatInfo`,params);};

export const GetMemberInfoByIcCard=params=>{return axios.get(`${base}/Business/GetMemberInfoByIcCard`,{params:params});};
//业务中心 Business 充值卡续充
export const RechargeableCardBusiness=params=>{return axios.post(`${base}/Business/RechargeableCard`,params);};
//业务中心 Business 充值卡业务办理
export const RechargeableCardCheck=params=>{return axios.get(`${base}/Business/RechargeableCardCheck`,{params:params});};
export const OwnerBusiness=params=>{return axios.post(`${base}/Business/Owner`,params);};



//业务中心 Business 消费前会员状态确认
export const MemberState=params=>{return axios.post(`${base}/Business/MemberState`,params);};
//消费前数据展示
export const GetConsumptionData=params=>{return axios.post(`${base}/Business/GetConsumptionData`,params);};
export const GenereerNewId=params=>{return axios.post(`${base}/Business/NewConsumptionId`,params);};



//业务中心 Business 消费
export const FrequencyCardConsumption=params=>{return axios.post(`${base}/Business/FrequencyCardConsumption`,params);};
export const MonthCardConsumption=params=>{return axios.post(`${base}/Business/MonthCardConsumption`,params);};
export const YearCardConsumption=params=>{return axios.post(`${base}/Business/YearCardConsumption`,params);};
export const RechargeableCardConsumption=params=>{return axios.post(`${base}/Business/RechargeableCardConsumption`,params);};
export const TrainingCardConsumption=params=>{return axios.post(`${base}/Business/TrainingCardConsumption`,params);};
export const CancelConsumption=params=>{return axios.post(`${base}/Business/CancelConsumption`,params);};
export const Reset=params=>{return axios.post(`${base}/Business/ResetCard`,params);};//重置业务
export const ResetCardTraining=params=>{return axios.post(`${base}/Business/ResetCardTraining`,params);};//重置业务
export const ResetCardChangeShift=params=>{return axios.post(`${base}/Business/ResetCardChangeShift`,params);};//重置业务

export const GetPageByConsumption=params=>{return axios.get(`${base}/Member/GetPageByConsumption`,{params:params})};
//闸机箱柜相关
export const PreparationsCreate=params=>{return axios.post(`${base}/Preparations/Create`,params);};
export const CancelPreparations=params=>{return axios.post(`${base}/Preparations/Cancel`,params);};
export const PreparationsList=params=>{return axios.get(`${base}/Preparations/GetPaging`,{params:params})};



//微信线上控制
export const getWeChatOnlineSetList=params=>{return axios.get(`${base}/WeChatOnlineSet/GetList`,{params:params})};
export const addWeChatOnlineSet=params=>{return axios.post(`${base}/WeChatOnlineSet/Create`,params);};
export const ChangeState=params=>{return axios.post(`${base}/WeChatOnlineSet/Change`,params);};
export const initData=params=>{return axios.post(`${base}/WeChatOnlineSet/init`,params);};

//门票管理
export const TicketList=params=>{return axios.get(`${base}/Ticket/GetPaging`,{params:params});};
export const addTicket=params=>{return axios.post(`${base}/Ticket/Create`,params);};
export const editTicket=params=>{return axios.post(`${base}/Ticket/Edit`,params);};
export const removeTicket=params=>{return axios.post(`${base}/Ticket/Delete`,params);};
export const TicketChangeState=params=>{return axios.post(`${base}/Ticket/Change`,params);};
export const TicketExportReport=params=>{return axios.post(`${base}/Ticket/ExportReport`,params,{responseType: 'blob'});};
//设备管理

export const MachineList=params=>{return axios.get(`${base}/Machine/GetPaging`,{params:params});};
export const addMachine=params=>{return axios.post(`${base}/Machine/Create`,params);};
export const editMachine=params=>{return axios.post(`${base}/Machine/Edit`,params);};
export const removeMachine=params=>{return axios.post(`${base}/Machine/Delete`,params);};
// 赛事队伍相关
export const GetInfo=params=>{return axios.post(`${base}/CompetitionTeam/GetInfo`,params);};
export const EditInfo=params=>{return axios.post(`${base}/CompetitionTeam/EditInfo`,params);};
export const getTeamList=params=>{return axios.get(`${base}/CompetitionTeam/GetPaging`,{params:params})};

export const GetLeaderInfo=params=>{return axios.post(`${base}/CompetitionTeamLeader/GetInfo`,params);};
export const EditLeaderInfo=params=>{return axios.post(`${base}/CompetitionTeamLeader/EditInfo`,params);};

//--赛事工作人员
export const getTeamStaffList=params=>{return axios.get(`${base}/CompetitionTeamStaff/GetList`,{params:params})};

export const TeamStaffList=params=>{return axios.get(`${base}/CompetitionTeamStaff/GetPaging`,{params:params});};
export const addTeamStaff=params=>{return axios.post(`${base}/CompetitionTeamStaff/Create`,params);};
export const editTeamStaff=params=>{return axios.post(`${base}/CompetitionTeamStaff/Edit`,params);};
export const removeTeamStaff=params=>{return axios.post(`${base}/CompetitionTeamStaff/Delete`,params);};
//--运动员
export const getTeamPlayerList=params=>{return axios.get(`${base}/CompetitionTeamPlayer/GetList`,{params:params})};

export const TeamPlayerList=params=>{return axios.get(`${base}/CompetitionTeamPlayer/GetPaging`,{params:params});};
export const addTeamPlayer=params=>{return axios.post(`${base}/CompetitionTeamPlayer/Create`,params);};
export const editTeamPlayer=params=>{return axios.post(`${base}/CompetitionTeamPlayer/Edit`,params);};
export const removeTeamPlayer=params=>{return axios.post(`${base}/CompetitionTeamPlayer/Delete`,params);};
export const UpdateTeamPlayer=params=>{return axios.post(`${base}/CompetitionTeamPlayer/UpdateTeamPlayer`,params);};
export const CheckLicenseNumber=params=>{return axios.post(`${base}/CompetitionTeamPlayer/CheckLicenseNumber`,params);};

//赛事组织
export const CompetitionList=params=>{return axios.get(`${base}/Competition/GetPaging`,{params:params});};
export const addCompetition=params=>{return axios.post(`${base}/Competition/Create`,params);};
export const editCompetition=params=>{return axios.post(`${base}/Competition/Edit`,params);};
export const removeCompetition=params=>{return axios.post(`${base}/Competition/Delete`,params);};
export const ChangeCompetitionState=params=>{return axios.post(`${base}/Competition/ChangeState`,params);};
export const CompetitionEntryList=params=>{return axios.get(`${base}/Competition/GetPageByShop`,{params:params});};
export const CompetitionFileList=params=>{return axios.get(`${base}/Competition/GetFileList`,{params:params});};
export const DeleteCompetitionFile=params=>{return axios.post(`${base}/Competition/DeleteFile`,params);};
export const UploadFile=params=>{return axios.post(`${base}/Competition/UploadFile`,params);};
// export const DownFile=params=>{return axios.post(`${base}/Competition/DownFile`,params);};
export const DownFile=params=>{return axios.post(`${base}/Competition/DownFile`,params,{responseType: 'blob'});};






//赛事报名
export const EntryList=params=>{return axios.get(`${base}/CompetitionEntry/GetPaging`,{params:params});};
export const getCompetitionEntryList=params=>{return axios.get(`${base}/CompetitionEntry/GetList`,{params:params})};
export const addCompetitionEntry=params=>{return axios.post(`${base}/CompetitionEntry/Create`,params);};
export const editCompetitionEntry=params=>{return axios.post(`${base}/CompetitionEntry/Edit`,params);};
export const removeCompetitionEntry=params=>{return axios.post(`${base}/CompetitionEntry/Delete`,params);};
export const EntryPlayerInfo=params=>{return axios.post(`${base}/CompetitionEntry/EntryPlayer`,params);};
export const EntryStaff=params=>{return axios.post(`${base}/CompetitionEntry/EntryStaff`,params);};
export const EntryRelayInfo=params=>{return axios.post(`${base}/CompetitionEntry/EntryRelay`,params);};
export const ExportEntryReport = params => { return axios.post(`${base}/CompetitionEntry/ExportEntryReport`,params,{responseType: 'blob'});};
export const DownSumWord=params=>{return axios.post(`${base}/CompetitionEntry/ExportReportSumWord`,params,{responseType: 'blob'});};
export const DownRoster=params=>{return axios.post(`${base}/CompetitionEntry/ExportReportRoster`,params,{responseType: 'blob'});};
           


export const UploadEntryImage=params=>{return axios.post(`${base}/CompetitionEntry/Upload`,params);};
//赛事分类
export const CompetitionTypeList=params=>{return axios.get(`${base}/CompetitionType/GetPaging`,{params:params});};
export const getCompetitionTypeList=params=>{return axios.get(`${base}/CompetitionType/GetList`,{params:params})};
export const addCompetitionType=params=>{return axios.post(`${base}/CompetitionType/Create`,params);};
export const editCompetitionType=params=>{return axios.post(`${base}/CompetitionType/Edit`,params);};
export const removeCompetitionType=params=>{return axios.post(`${base}/CompetitionType/Delete`,params);};
export const ChangeCompetitionTypeState=params=>{return axios.post(`${base}/CompetitionType/ChangeState`,params);};
//赛事组
export const getCompetitionGroupList=params=>{return axios.get(`${base}/CompetitionGroup/GetList`,{params:params})};

export const CompetitionGroupList=params=>{return axios.get(`${base}/CompetitionGroup/GetPaging`,{params:params});};
export const addCompetitionGroup=params=>{return axios.post(`${base}/CompetitionGroup/Create`,params);};
export const editCompetitionGroup=params=>{return axios.post(`${base}/CompetitionGroup/Edit`,params);};
export const removeCompetitionGroup=params=>{return axios.post(`${base}/CompetitionGroup/Delete`,params);};
export const CheckGroup=params=>{return axios.post(`${base}/CompetitionGroup/CheckGroup`,params);};
export const GroupList=params=>{return axios.post(`${base}/CompetitionGroup/GroupList`,params);};
export const GetListGroupByType=params=>{return axios.post(`${base}/CompetitionGroup/GetListGroupByType`,params);};



//泳姿设置
export const CompetitionPostureList=params=>{return axios.get(`${base}/CompetitionPosture/GetPaging`,{params:params});};
export const getCompetitionPostureList=params=>{return axios.get(`${base}/CompetitionPosture/GetList`,{params:params})};
export const addCompetitionPosture=params=>{return axios.post(`${base}/CompetitionPosture/Create`,params);};
export const editCompetitionPosture=params=>{return axios.post(`${base}/CompetitionPosture/Edit`,params);};
export const removeCompetitionPosture=params=>{return axios.post(`${base}/CompetitionPosture/Delete`,params);};
export const ChangeCompetitionPostureState=params=>{return axios.post(`${base}/CompetitionPosture/ChangeState`,params);};

//赛事项目
export const GroupItemList=params=>{return axios.get(`${base}/CompetitionGroupItem/GetPaging`,{params:params});};
export const getGroupItemList=params=>{return axios.get(`${base}/CompetitionGroupItem/GetList`,{params:params})};
export const addGroupItem=params=>{return axios.post(`${base}/CompetitionGroupItem/Create`,params);};
export const editGroupItem=params=>{return axios.post(`${base}/CompetitionGroupItem/Edit`,params);};
export const removeGroupItem=params=>{return axios.post(`${base}/CompetitionGroupItem/Delete`,params);};
export const GetItemList=params=>{return axios.post(`${base}/CompetitionGroupItem/GetItemList`,params);};
export const GetListByRelay=params=>{return axios.post(`${base}/CompetitionGroupItem/GetListByRelay`,params);};

// 剩余业务统计
export const SurplusFrequencyCard=params=>{return axios.post(`${base}/Report/SurplusFrequencyCard`,params);};
export const SurplusYearCard=params=>{return axios.post(`${base}/Report/SurplusYearCard`,params);};
export const SurplusMonthCard=params=>{return axios.post(`${base}/Report/SurplusMonthCard`,params);};
export const SurplusRechargeableCard=params=>{return axios.post(`${base}/Report/SurplusRechargeableCard`,params);};
export const SurplusTrainingCard=params=>{return axios.post(`${base}/Report/SurplusTrainingCard`,params);};
export const SurplusOwnerCard=params=>{return axios.post(`${base}/Report/SurplusOwnerCard`,params);};
//剩余业务统计导出
export const ExportSurplusFrequencyCard=params=>{return axios.post(`${base}/Report/ExportSurplusFrequencyCard`,params,{responseType: 'blob'});};
export const ExportSurplusYearCard=params=>{return axios.post(`${base}/Report/ExportSurplusYearCard`,params,{responseType: 'blob'});};
export const ExportSurplusMonthCard=params=>{return axios.post(`${base}/Report/ExportSurplusMonthCard`,params,{responseType: 'blob'});};
export const ExportSurplusRechargeableCard=params=>{return axios.post(`${base}/Report/ExportSurplusRechargeableCard`,params,{responseType: 'blob'});};
export const ExportSurplusTrainingCard=params=>{return axios.post(`${base}/Report/ExportSurplusTrainingCard`,params,{responseType: 'blob'});};
export const ExportSurplusOwnerCard=params=>{return axios.post(`${base}/Report/ExportSurplusOwnerCard`,params,{responseType: 'blob'});};
//消费统计套餐查询列表
export const TrainingComboList=params=>{return axios.get(`${base}/Report/TrainingComboList`,{params:params})};
export const OwnerCardComboList=params=>{return axios.get(`${base}/Report/OwnerCardComboList`,{params:params})};
export const RechargeableCardComboList=params=>{return axios.get(`${base}/Report/RechargeableCardComboList`,{params:params})};
export const YearCardComboList=params=>{return axios.get(`${base}/Report/YearCardComboList`,{params:params})};
export const MonthCardComboList=params=>{return axios.get(`${base}/Report/MonthCardComboList`,{params:params})};
export const FrequencyCardComboList=params=>{return axios.get(`${base}/Report/FrequencyCardComboList`,{params:params})};


//门票订单 TicketOrder
export const TicketOrderList=params=>{return axios.get(`${base}/TicketOrder/GetPaging`,{params:params});};
// export const addTicket=params=>{return axios.post(`${base}/TicketOrder/Create`,params);};
// export const editTicketOrder=params=>{return axios.post(`${base}/TicketOrder/Edit`,params);};
// export const removeTicket=params=>{return axios.post(`${base}/TicketOrder/Delete`,params);};
export const TicketOrderChangeState=params=>{return axios.post(`${base}/TicketOrder/Verify`,params);};
export const SweepCode=params=>{return axios.post(`${base}/TicketOrder/SweepCode`,params);};


//报表相关


export const GetBusiness=params=>{return axios.post(`${base}/Report/GetBusiness`,params);};
export const ExportGetBusiness=params=>{return axios.post(`${base}/Report/ExportBusiness`,params,{responseType: 'blob'});};
export const ExportBusinessDetial=params=>{return axios.post(`${base}/Report/ExportBusinessDetial`,params,{responseType: 'blob'});};
export const ExportConsumptionReport=params=>{return axios.post(`${base}/Report/ExportConsumptionReport`,params,{responseType: 'blob'});};
export const ExportConsumptionReport2=params=>{return axios.post(`${base}/Report/ExportConsumptionReport2`,params,{responseType: 'blob'});};

export const ExportConsumptionDetials=params=>{return axios.post(`${base}/Report/ExportConsumptionDetials`,params,{responseType: 'blob'});};




export const BusinessDetial=params=>{return axios.post(`${base}/Report/BusinessDetial`,params);};
export const GetConsumptionReport=params=>{return axios.post(`${base}/Report/ConsumptionReport`,params);};
export const GetConsumptionReport2=params=>{return axios.post(`${base}/Report/ConsumptionReport2`,params);};
export const GetConsumptionReport3=params=>{return axios.post(`${base}/Report/ConsumptionReport3`,params);};
export const ExportConsumptionReport3Detials=params=>{return axios.post(`${base}/Report/ExportConsumptionReport3Detials`,params,{responseType: 'blob'});};



export const GetFlowReport=params=>{return axios.post(`${base}/Report/FlowReport`,params);};
export const ExportFlow=params=>{return axios.post(`${base}/Report/ExportFlow`,params,{responseType: 'blob'});};
export const GetFlowReportEcharts=params=>{return axios.post(`${base}/Report/FlowReportEcharts`,params);};
export const GetConsumptionReportEcharts=params=>{return axios.post(`${base}/Report/ConsumptionReportEcharts`,params);};
export const GetBusinessEcharts=params=>{return axios.post(`${base}/Report/BusinessEcharts`,params);};
export const GetCustomerTypeEcharts=params=>{return axios.post(`${base}/Report/CustomerTypeEcharts`,params);};
export const GetCustomerTypeReport=params=>{return axios.post(`${base}/Report/CustomerTypeReport`,params);};
export const GetConsumptionDetials=params=>{return axios.post(`${base}/Report/ConsumptionDetial`,params);};
export const GetFlowDataDetail=params=>{return axios.post(`${base}/Report/FlowDataDetail`,params);};
export const GetCustomerDetail=params=>{return axios.post(`${base}/Report/CustomerDetail`,params);};


//系统参数

export const QQCustomerService = params => { return axios.post(`${base}/SystemParameter/QQCustomerService`,   params ); };
export const VersionStyle = params => { return axios.post(`${base}/SystemParameter/VersionStyle`,   params ); };

//一卡通系统
export const OneCardConsumptionPage=params=>{return axios.get(`${base}/OneCardSystem/GetPageByConsumption`,{params:params})};
export const OneCardPage=params=>{return axios.get(`${base}/OneCardSystem/GetPaging`,{params:params})};
export const OneCardMemberState=params=>{return axios.post(`${base}/OneCardSystem/MemberState`,params);};

export const OneCardConsumptionData=params=>{return axios.post(`${base}/OneCardSystem/GetConsumptionData`,params);};
export const OneCardOptionsList=params=>{return axios.get(`${base}/OneCardSystem/GetList`,{params:params})};
export const OneCardConsumption=params=>{return axios.post(`${base}/OneCardSystem/RechargeableCardConsumption`,params);};

export const OneCardCancelConsumption=params=>{return axios.post(`${base}/OneCardSystem/CancelConsumption`,params);};

export const GetPageCensus=params=>{return axios.get(`${base}/OneCardSystem/GetPageCensus`,{params:params})};
export const OneCardSystemExport=params=>{return axios.post(`${base}/OneCardSystem/OneCardSystemExport`,params,{responseType: 'blob'});};


//设备管理

export const HandCardsList=params=>{return axios.get(`${base}/HandCards/GetPaging`,{params:params});};
export const addHandCards=params=>{return axios.post(`${base}/HandCards/Create`,params);};
export const editHandCards=params=>{return axios.post(`${base}/HandCards/Edit`,params);};
export const removeHandCards=params=>{return axios.post(`${base}/HandCards/Delete`,params);};
//承诺函签署
export const LetterSignList=params=>{return axios.get(`${base}/LetterSign/GetPaging`,{params:params});};
export const addLetterSign=params=>{return axios.post(`${base}/LetterSign/Create`,params);};
export const editLetterSign=params=>{return axios.post(`${base}/LetterSign/Edit`,params);};
export const removeLetterSign=params=>{return axios.post(`${base}/LetterSign/Delete`,params);};

//承诺函设置
export const LetterTemplateList=params=>{return axios.get(`${base}/LetterTemplate/GetPaging`,{params:params});};
export const addLetterTemplate=params=>{return axios.post(`${base}/LetterTemplate/Create`,params);};
export const editLetterTemplate=params=>{return axios.post(`${base}/LetterTemplate/Edit`,params);};
export const removeLetterTemplate=params=>{return axios.post(`${base}/LetterTemplate/Delete`,params);};
//充值记录管理
export const RechargeRecordList=params=>{return axios.get(`${base}/RechargeRecord/GetPaging`,{params:params});};
export const addRechargeRecord=params=>{return axios.post(`${base}/RechargeRecord/Create`,params);};
export const editRechargeRecord=params=>{return axios.post(`${base}/RechargeRecord/Edit`,params);};
export const removeRechargeRecord=params=>{return axios.post(`${base}/RechargeRecord/Delete`,params);};
export const RechargeRecordCancel=params=>{return axios.post(`${base}/RechargeRecord/Cancel`,params);};
export const RechargeRecordExport = params => { return axios.post(`${base}/RechargeRecord/Export`,params,{responseType: 'blob'});};

//手环游泳数据

export const GetMotionGroupDataPageListByCardNo=params=>{return axios.get(`${base}/SwimmingData/GetMotionGroupDataPageListByCardNo`,{params:params});};
export const GetAppointMotionGroupDataDetail=params=>{return axios.get(`${base}/SwimmingData/GetAppointMotionGroupDataDetail`,{params:params});};



export const SwimmingDataPage=params=>{return axios.get(`${base}/SwimmingData/GetPaging`,{params:params});};
export const SwimmingDataCreate=params=>{return axios.post(`${base}/SwimmingData/Create`,params);};
export const SwimmingDataEdit=params=>{return axios.post(`${base}/SwimmingData/Edit`,params);};
export const SwimmingDataDelete=params=>{return axios.post(`${base}/SwimmingData/Delete`,params);};
export const SetStatePass=params=>{return axios.post(`${base}/SwimmingData/SetStatePass`,params);};
export const SetStateUnPass=params=>{return axios.post(`${base}/SwimmingData/SetStateUnPass`,params);};
export const SwimmingDataExportData = params => { return axios.post(`${base}/SwimmingData/Export`,params,{responseType: 'blob'});};

//水质监测管理

export const WaterQualityPag=params=>{return axios.get(`${base}/WaterQuality/GetPaging`,{params:params});};
export const WaterQualityCreate=params=>{return axios.post(`${base}/WaterQuality/Create`,params);};
export const WaterQualityEdit=params=>{return axios.post(`${base}/WaterQuality/Edit`,params);};
export const WaterQualityDelete=params=>{return axios.post(`${base}/WaterQuality/Delete`,params);};
export const WaterQualityExportData = params => { return axios.post(`${base}/WaterQuality/ExportData`,params,{responseType: 'blob'});};

//水表

export const WaterDataPag=params=>{return axios.get(`${base}/ElectricityAndWater/GetPaging`,{params:params});};
export const WaterDataCreate=params=>{return axios.post(`${base}/ElectricityAndWater/Create`,params);};
export const WaterDataEdit=params=>{return axios.post(`${base}/ElectricityAndWater/Edit`,params);};
export const WaterDataDelete=params=>{return axios.post(`${base}/ElectricityAndWater/Delete`,params);};
export const WaterDataExportData = params => { return axios.post(`${base}/ElectricityAndWater/ExportData`,params,{responseType: 'blob'});};

//电表
export const WattHourMeterPag=params=>{return axios.get(`${base}/WattHourMeter/GetPaging`,{params:params});};
export const WattHourMeterCreate=params=>{return axios.post(`${base}/WattHourMeter/Create`,params);};
export const WattHourMeterEdit=params=>{return axios.post(`${base}/WattHourMeter/Edit`,params);};
export const WattHourMeterDelete=params=>{return axios.post(`${base}/WattHourMeter/Delete`,params);};
export const WattHourMeterExportData = params => { return axios.post(`${base}/WattHourMeter/ExportData`,params,{responseType: 'blob'});};












































//测试用
// export const requestLogin = params => { return axios.post(`${base}/user/login`, params).then(res => res.data); };



// export const getUserList = params => { return axios.get(`${base}/Member/list`, { params: params }); };

// export const getUserListPage = params => { return axios.get(`${base}/Member/listpage`, { params: params }); };

// export const removeUser = params => { return axios.get(`${base}/Member/remove`, { params: params }); };

// export const batchRemoveUser = params => { return axios.get(`${base}/Member/batchremove`, { params: params }); };

// export const editUser = params => { return axios.get(`${base}/Member/edit`, { params: params }); };







// WEBPACK FOOTER //
// ./src/api/api.js